<template>
    <LineChartGenerator

            :options="chartOptions"
            :data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
    />


</template>

<script>
    import {Line as LineChartGenerator} from 'vue-chartjs'
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement,

    } from 'chart.js'

    ChartJS.register(
        Title,
        Tooltip,
        Legend,
        LineElement,
        LinearScale,
        CategoryScale,
        PointElement, ChartDataLabels
    )

    export default {
        name: 'LineChart',
        components: {
            LineChartGenerator
        },
        props: {
            chartId: {
                type: String,
                default: 'line-chart'
            },
            datasetIdKey: {
                type: String,
                default: 'label'
            },
            width: {
                type: Number,
                default: 400
            },
            height: {
                type: Number,
                default: 400
            },
            cssClasses: {
                default: '',
                type: String
            },
            styles: {
                type: Object,
                default: () => {
                }
            },
            plugins: {
                type: Array,
                default: () => []
            },
            chartData: {
                type: Object,
                default: () => {
                }
            },

        },
        data() {
            return {
                chartOptions: {
                    responsive: true,
                    tension:0.4,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            min: 0,
                        }
                    },
                    plugins: {
                        datalabels: {
                            // color: "black",
                            anchor: 'end',
                            align: 'left',
                            display: 'auto',
                            font: {
                                weight: "bold",
                                size: 10
                            },
                            formatter: function(value) {
                                // var index = context.dataIndex
                                // var previousValue = context.dataset.data[index - 1] || context.dataset.data[index ]
                                // if(previousValue==0){
                                //     return 0 + ' (0%)'
                                // }
                                // var growthPercentage = ((value - previousValue) / previousValue) * 100
                                // if(isNaN(growthPercentage)){
                                //     return 0 + ' (0%)'
                                //
                                // }else {
                                //
                                // }

                                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ;
                                // return value+ ' LAK';
                            }

                        },

                    },




                },



            }
        }

    }
</script>
